import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from 'redux';
import { updateHeader } from "~app/actions/nodeList";
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import { withT } from "~app/BundleProvider";

class NodeListHeader extends Component {
  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    updateHeader: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: "",
    description: "",
    showTextArea: false,
  }

  constructor(props) {
    super(props);

    this.state = {
      title: this.props.title,
      description: this.props.description,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.title !== this.state.title) {
      this.setState({ title: nextProps.title });
    }
    if (nextProps.description !== this.state.description) {
      this.setState({ description: nextProps.description });
    }
  }

  handleChangeTitle = event => this.setState({ title: event.target.value });

  handleChangeDescription = event => this.setState({ description: event.target.value });

  updateHeader() {
    this.props.updateHeader({
      title: this.state.title,
      description: this.state.description,
    });
  }

  updateTitle = event => {
    if (this.state.title !== this.props.title) {
      this.updateHeader();
    }
  };

  updateDescription = event => {
    if (this.state.description !== this.props.description) {
      this.updateHeader();
    }
  };

  render() {
    const { t } = this.props;
    return (
      <div className="NodeListHeader">
        <div className="NodeListHeader__title-wrapper">
        <input
          className="HeaderTitle"
          placeholder={t("example-project-name")}
          aria-label={t("edit-project-name")}
          value={this.state.title}
          onChange={this.handleChangeTitle}
          onBlur={this.updateTitle}
        />
        <div
          role="button"
          tabIndex="0"
          aria-label={t("expand-collapse-description")}
          onClick={() => this.setState({ showTextArea: !this.state.showTextArea })}
          onKeyPress={(event) => {
              if(event.key === 'Enter' || event.key === ' '){
                this.setState({ showTextArea: !this.state.showTextArea });
              }
            }}
          className={classNames("NodeHeader__chevron header", {"NodeHeader__chevron--open":this.state.showTextArea})}
        />
        </div>

        <div className="HeaderContent">
          <div className="HeaderDescription">
            <AnimateHeight duration={200} height={this.state.showTextArea ? 205 : 25 } >
            { this.state.showTextArea
              ? (
                <textarea
                  className="HeaderDescription__textarea"
                  placeholder={t("add-description")}
                  aria-label={t("add-description-input")}
                  value={this.state.description}
                  onChange={this.handleChangeDescription}
                  onBlur={this.updateDescription}
                />
              )
              : (
                <input
                  className="HeaderDescription__input"
                  placeholder={t("add-description")}
                  aria-label={t("add-description-input")}
                  value={this.state.description}
                  onChange={this.handleChangeDescription}
                  onBlur={this.updateDescription}
                />
              )
            }
            </AnimateHeight>

          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateHeader,
};

export { NodeListHeader };
export default compose(
  withT,
  connect(null, mapDispatchToProps)
)(NodeListHeader);



// WEBPACK FOOTER //
// ./src/pages/Main/NodeList/NodeListHeader.js